import { ITranslationKey } from '../../ITranslationKey';
import { ITranslationUpdateContext } from './BaseTranslationSchema';
import { TranslationArraySchema } from './TranslationArraySchema';
import { TranslationStringSchema } from './TranslationStringSchema';

/**
 * Per l'RTE supportiamo:
 * 1. Il caso in cui il testo sia un array
 * 2. Il caso "fallback" in cui il testo sia una stringa, per i campi
 *    "Semplici"
 */
export class TranslationRteSchema extends TranslationArraySchema {
  private previousSimpleRteSchema = new TranslationStringSchema();

  extract(value: any, path = '', prefix = ''): ITranslationKey[] {
    if (value && typeof value === 'string') {
      return this.previousSimpleRteSchema.extract(value, path, prefix);
    }

    return super.extract(value, path, prefix);
  }

  translateValue(
    value: any,
    path: string,
    prefix: string,
    ctx: ITranslationUpdateContext,
  ) {
    if (value && typeof value === 'string') {
      return this.previousSimpleRteSchema.translateValue(
        value,
        path,
        prefix,
        ctx,
      );
    }

    return super.translateValue(value, path, prefix, ctx);
  }
}
